import styled from 'styled-components';

export const KeyboardKey = ({ children }: { children: React.ReactNode }) => {
  return (
    <Container>
      <Text>{children}</Text>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: inline-block;
  margin: 0 7px;
  translate: 0 -1px;

  &::before {
    content: '';
    position: absolute;
    z-index: 0;
    top: -1px;
    left: -5px;
    width: 100%;
    height: calc(100% - 3px);
    padding: 2px 4px;
    border-radius: 5px;
    border: 1px solid var(--main-2);
    border-bottom: 2px solid var(--main-1);
  }
`;

const Text = styled.div`
  z-index: 1;

  color: var(--main-1);
  font-family: var(--font-3);
  font-size: 11px;
`;
